/* Universal javascript */

import Alpine from 'alpinejs';
import persist from '@alpinejs/persist'

import './alpine/store.js';
import './alpine/popovers.js';
import './alpine/skeleton.js';
import './alpine/whereAutocomplete.js';
// import './components/heroSearch.js';
import './components/bookingFlow.js';
import listingBooking from './alpine/listingBooking.js';
import { priceRange } from './components/priceRange.js';
import { inlineBirdhouseAnimation } from './components/inlineBirdhouseAnimation.js';
import { asideAnimation } from './components/asideAnimation.js';

import disableTransitionOnResize from './utils/disableTransitionOnResize.js'
import swiper from './utils/swiper.js'
import animateIn from './utils/animateIn.js'
import htmxEvents from './utils/htmx.js'
import refreshCsrfToken from './utils/refresh-csrf-token.js'
import { initAuthListeners, initCardClickTracking, initViewItem } from './utils/dataLayer.js'


// Register Alpine components
Alpine.data('listingBooking', listingBooking);

window.Alpine = Alpine;
Alpine.plugin(persist);
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
    disableTransitionOnResize.init();
    swiper.init()
    inlineBirdhouseAnimation.init();
    asideAnimation.init();
    animateIn.init();
    priceRange.autoInit();
    priceRange.watchDialogs();

    htmxEvents.init();
    initAuthListeners();
    initCardClickTracking();
    initViewItem();

    // Fetch CSRF token async and expose globally for getCsrfToken() helper
    refreshCsrfToken.init().then(() => {
        window.__csrfToken = refreshCsrfToken.getToken();
    });

    // Keep window.__csrfToken in sync on subsequent refreshes (e.g. after htmx swaps)
    document.addEventListener('csrf:refreshed', (e) => {
        window.__csrfToken = e.detail;
    });
});
